import config from '@/config';
import { MAX_RECENTLY_PLAYED_GAMES } from '@/logic/main/constants';
import { ControllersData, LogicContext } from '@/logic/main/types';
import { extractRecentlyPlayedType } from '@/logic/main/utils';
import models from '@/model';
import { getLocale } from '@/utils';




function getGamesNumberLimit(controllersData?: ControllersData): number {
  if (controllersData && controllersData.recentlyPlayed) {
    const { cmpType, gamesNumberLimitFromCMS } = extractRecentlyPlayedType(
      controllersData.recentlyPlayed
    );

    if (cmpType === 'Grid' && gamesNumberLimitFromCMS) {
      return gamesNumberLimitFromCMS;
    }
  }
  return MAX_RECENTLY_PLAYED_GAMES;
}

export const fetchRecentlyPlayedGames = (context: LogicContext) => async () => {
  const authToken = context.user?.authToken?.access_token;
  const { controllersData } = context;

  const { status, data } = authToken
    ? await models.fetchRecentlyPlayed({
        authToken,
        locale: getLocale(config),
        market_country: config.viewer_country,
        market_region: config.viewer_region,
        limit: getGamesNumberLimit(controllersData),
      })
    : { status: 401, data: [] };

  return {
    status,
    recentlyPlayedGamesList: data,
  };
};
